import React, { Component } from 'react';
import $ from 'jquery';
import { toggleSubmitActive } from '../../../../redux/testPage/testPage.actions';
import {
	setResetCounter,
	handleBlobChange,
} from '../../../../redux/utilities/utils.actions';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import {
	stopAllAudio,
	enableAudio,
	recordAudio,
} from '../../../../utils/commonFunctions';
import Loader from '../../../../utils/Loader';

var audio = {};
var recorder;
var videoTimerInterval,videoMaxTime;

class IosAudioRecorder extends Component {
	constructor(props) {
		super(props);
		this.state = {
			status: 'start',
			audioSrc: '',
			isMicPermitted: false,
			onRecorderClick: () => this.startRecording,
			inactive: true,
		};
		this.startRecording = this.startRecording.bind(this);
		this.stopRecording = this.stopRecording.bind(this);
		this.initialiseRecorder = this.initialiseRecorder.bind(this);
	}

	componentDidMount() {
		this.initialiseRecorder();
	}

	initialiseRecorder = async () => {
		recorder = await recordAudio();
		return recorder;
	};

	startRecording = async () => {
		const { index, qtype } = this.props;
		await this.initialiseRecorder();
		recorder.start();
		this.setState({ inactive: false});
		let newVideoTimer = 0;
	  
		if (qtype.toLowerCase() == 'ielts' || qtype == 'IELTS') {
		  videoMaxTime = 120;
		} else {
		  videoMaxTime = 45;
		}
	  
		const intervalMilliseconds = 1000;
	  
		const intervalsToMaxTime = videoMaxTime * 1000 / intervalMilliseconds;
	  
		videoTimerInterval = setInterval(() => {
		  newVideoTimer++;
	  	 if (newVideoTimer >= intervalsToMaxTime) {
			clearInterval(videoTimerInterval);
	  
			if (!!index) {
			  $(`.audioRecorder[index=${index}] .icon-stop`).click();
			} else {
			  $(`.audioRecorder .icon-stop`).click();
			}
		  }
		}, intervalMilliseconds);

	  
		

		stopAllAudio();
		$(`.audioRecorder[index=${index}]`).closest('.speaking-question').focus();
		if (typeof index !== 'undefined') {
			let recorders = $(`.audioRecorder[index!=${index}] .icon-stop`);

			for (var i = 0, len = recorders.length; i < len; i++) {
				recorders[i].click();
			}
		}
	};

	stopRecording = async () => {
		const {
			clozeConvo,
			index,
			qtype,
			resetCounter,
			resetCounters,
			updateCounter,
			updateCounters,
			handleBlobChange,
			toggleSubmitActive,
		} = this.props;
		audio = {};
		audio = await recorder.stop();
		this.setState({ inactive: true });
		clearInterval(videoTimerInterval);
		if (!!resetCounter) {
			updateCounter();
		} else if (!!resetCounters && resetCounters.length > 0) {
			updateCounters(index);
		}
		let blob = audio.audioBlob;
		handleBlobChange({ blob, index });
		document.getElementById(`player_${index}`).src = audio.audioUrl;
		document.getElementById(`audioLoader_${index}`).load();
		if (clozeConvo) {
			if ($('.converse-nil')) {
				$('.converse-nil').focus();
			}
		} else {
			if (qtype.toLowerCase() === 'wordcloud') {
				if (!$('.arrange-words-inposition span').hasClass('avail'))
					toggleSubmitActive(false);
			} else if (qtype.toLowerCase() === 'cloze_with_passage') {
				if (!$('.quiz-area-options span').hasClass('to-be-filled'))
					toggleSubmitActive(false);
			} else toggleSubmitActive(false);
		}

		if (!$(`.icon-stop_${index}`).is(':visible')) {
			enableAudio();
		}
		Loader.hide();
	};

	render() {
		const { inactive } = this.state;
		const { index } = this.props;



		return (
			<div className="audioRecorder" index={index}>
				<p>
					{inactive ? (
						<button
							aria-label="start-recording"
							id="record"
							onClick={this.startRecording}
							className={`iconfont icon_start_${index} icon-start icon-start_cloze `}
						></button>
					) : (
						<div>
							<button
								aria-label="start-recording"
								id="record"
								className={`iconfont icon_stop_${index} icon-stop`}
								onClick={this.stopRecording}
							></button>
							<h6>
								<span className="test_message">Listening for audio</span>
								<div className="spinner">
									<div className="bounce1"></div>
									<div className="bounce2"></div>
									<div className="bounce3"></div>
								</div>
							</h6>
						</div>
					)}
				</p>

				<p>
					<audio controls id={`audioLoader_${index}`} className="block-center">
						<source src="" type="audio/mpeg" id={`player_${index}`} />
						Your browser does not support the audio element.
					</audio>
				</p>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		rightSectionProps: { resetCounter, resetCounters },
		leftSectionProps: { qtype },
		questionNo,
		isMicPermitted,
	} = state.rootReducer.testPageDetails;

	return {
		resetCounter,
		resetCounters,
		questionNo,
		isMicPermitted,
		qtype,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		toggleSubmitActive: (val) => dispatch(toggleSubmitActive(val)),
		setResetCounter: (val) => dispatch(setResetCounter(val)),
		handleBlobChange: ({ blob, index }) =>
			dispatch(handleBlobChange({ blob, index })),
	};
};
export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(IosAudioRecorder);


